import { formatAmountWithUnit } from "@loot-os/api-contract";
import type { BalanceResponse } from "@loot-os/client";
import { Badge } from "@loot-os/ui/components/badge";
import { CurrencyIcon } from "@loot-os/ui/components/currency-icon";

import { spendableCents } from "../lib/balance.js";
import { useCurrency } from "../lib/currency.js";

/**
 * The shopper's spendable balance in the store's currency (GET /v1/me/balance): `balanceCents`
 * net of `heldCents`, so an open drops it at the reveal and the claim leaves it where it is.
 */
export function BalanceBadge({ balance }: { balance: BalanceResponse | null }) {
  const currency = useCurrency();
  if (!balance) return null;
  return (
    <Badge variant="secondary" className="gap-1 font-mono text-xs">
      <CurrencyIcon currency={currency} /> {formatAmountWithUnit(spendableCents(balance), currency)}
    </Badge>
  );
}
